/**
 * Created by shubham on 13/6/18.
 */

import { Routes, RouterModule }  from '@angular/router';
import { FileUploadComponent } from './fileUpload.component';
import { FileUploadListComponent } from './fileUploadList/fileUploadList.component';
import { AddFileComponent } from './add-file/addFile.component';

export const FileUploadRoutes: Routes = [
    {
        path: '',
        component: FileUploadComponent,
        children: [
            { path: '', redirectTo: '/app/profile', pathMatch: 'full' },
            { path: 'list', component: FileUploadListComponent },
            { path: 'add', component: AddFileComponent },
        ]
    }
];

export const FileUploadRoutingModule = RouterModule.forChild(FileUploadRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/file-upload/fileUpload-routing.module.ts